var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationsLarge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Application") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/70/Application",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#D8D8DE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "17.886075 26.5957304 0.145644002 26.5957304 0.145644002 0 26.3149583 0 26.3149583 19.4162577"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(13.230301, 56.608456) rotate(-90.000000) translate(-13.230301, -56.608456) ",
    points: "3.02183518 69.8387576 0.0788237085 69.8387576 0.0788237085 43.3781554 26.3817785 43.3781554 26.3817785 55.0651464"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#EEF0F3",
    cx: 40.3290635,
    cy: 43.0816628,
    rx: 18.8521104,
    ry: 18.9483837
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(56.769699, 13.297865) rotate(-270.000000) translate(-56.769699, -13.297865) ",
    points: "59.1934887 26.5281663 43.6182215 26.5281663 43.6182215 0.0675640633 69.9211763 0.0675640633 69.9211763 7.71481719"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.1671088,
    y1: 69.4245808,
    x2: 53.7242395,
    y2: 56.6084565,
    id: "Path-4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsLarge);
export default __webpack_public_path__ + "static/media/applications-large.fcf26943334b874effeccc4b6d405641.svg";
export { ForwardRef as ReactComponent };